import { SharedUtils } from "../utilities/shared-utils";
import { CitizenInfo } from "./citizen-info";
import { LegalEntityBasicInfo } from "./legal-entity-basic-info";
import { LegalEntityInfo } from "./legal-entity-info";
import { EnumRoleFullIdentifier, EnumUserRole, UserBasicInfo } from "./user-basic-info";
import { EnumUserLegalEntityRole, UserLegalEntityInfo } from "./user-legal-entity-info";

export class UserInfo extends UserBasicInfo {

    dateStart: Date | undefined;

    declare citizenInfo: CitizenInfo | undefined;
    legalEntitiesBasicInfo:LegalEntityBasicInfo[] | undefined;
    activeLegalEntityInfo: LegalEntityInfo | undefined;
    activeUserLegalEntityInfo: UserLegalEntityInfo | undefined;

    public getAuthorities(): EnumRoleFullIdentifier[] {
        // console.log("UserInfo.getAuthorities() - roles:", JSON.stringify(this.roles));
        let rolesList:Array<EnumRoleFullIdentifier> = new Array<EnumRoleFullIdentifier>();
        if (this.roles && this.roles.length > 0) {
            if(this.activeUserLegalEntityInfo?.userLegalEntityRoles && this.activeUserLegalEntityInfo?.userLegalEntityRoles.length > 0) {
                this.roles.forEach( (userRole: EnumUserRole) => {
                    // console.log("UserInfo.getAuthorities() - userRole: ", userRole);
                    this.activeUserLegalEntityInfo!.userLegalEntityRoles!.forEach( (userLegalEntityRole: EnumUserLegalEntityRole) => {
                        // console.log("UserInfo.getAuthorities() - userLegalEntityRole: ", userLegalEntityRole);
                        const tempString: string = userRole + "." + this.activeUserLegalEntityInfo?.legalEntityRole + "." + userLegalEntityRole;
                        // console.log("UserInfo.getAuthorities() - tempString: ", tempString);
                        rolesList.push(tempString as unknown as EnumRoleFullIdentifier);
                    });
                });
            } else {
                this.roles.forEach( (userRole: EnumUserRole) => {
                    const tempString: string = userRole + ".NONE.NONE";
                    rolesList.push(tempString as unknown as EnumRoleFullIdentifier);
                });
            }
        }
        // console.log("UserInfo.getAuthorities() - rolesList:", JSON.stringify(rolesList));
        return rolesList;
    }

    public static parseUserInfo(stringifiedUserInfo: UserInfo): UserInfo | undefined {
        if(SharedUtils.inputValueIsEmpty(stringifiedUserInfo)) {
            return undefined;
        }
        const newUserInfo = new UserInfo();

        newUserInfo.id = stringifiedUserInfo.id;
        newUserInfo.nickname = stringifiedUserInfo.nickname;
        newUserInfo.email = stringifiedUserInfo.email;
        // newUserInfo.token = stringifiedUserInfo.token;
        newUserInfo.statusId = stringifiedUserInfo.statusId;
        // newUserInfo.instagramNickname = stringifiedUserInfo.instagramNickname;
        newUserInfo.roles = new Array<EnumUserRole>();
        if (stringifiedUserInfo.roles) {
            let counter: number = stringifiedUserInfo.roles.length;
            for (let i : number = 0; i < counter; i++) {
                newUserInfo.roles.push(stringifiedUserInfo.roles[i]);
            }
        } else {
            throw new Error("ERROR - CookieService: User profile not found:  UserInfo.roles: " + stringifiedUserInfo.roles);
        }
        newUserInfo.rolesNew = new Array<EnumUserRole>();
        if (stringifiedUserInfo.rolesNew) {
            let counter: number = stringifiedUserInfo.rolesNew.length;
            for (let i : number = 0; i < counter; i++) {
                newUserInfo.rolesNew.push(stringifiedUserInfo.rolesNew[i]);
            }
        }
        newUserInfo.dateStart = (stringifiedUserInfo.dateStart as Date) ?? undefined;
        // newUserInfo.password = stringifiedUserInfo.password;
        // newUserInfo.confirmPassword = stringifiedUserInfo.confirmPassword;
        newUserInfo.citizenInfo = CitizenInfo.parseCitizenInfo(stringifiedUserInfo.citizenInfo ?? new CitizenInfo());
        // newUserInfo.userLegalEntitiesAttributesBasicInfo = this.parseUserLegalEntitiesAttributesBasicInfo(stringifiedUserInfo.userLegalEntitiesAttributesBasicInfo);
        if(SharedUtils.inputValueIsPresent(stringifiedUserInfo.legalEntitiesBasicInfo)) {
            newUserInfo.legalEntitiesBasicInfo = new Array<LegalEntityBasicInfo>();
            stringifiedUserInfo.legalEntitiesBasicInfo!.map((entity: LegalEntityBasicInfo) => {
                const parsedEntity = LegalEntityBasicInfo.parseLegalEntityBasicInfo(entity);
                if (parsedEntity) {
                    newUserInfo.legalEntitiesBasicInfo!.push(parsedEntity);
                }
            });
        }
        newUserInfo.activeLegalEntityInfo = LegalEntityInfo.parseLegalEntityInfo(stringifiedUserInfo.activeLegalEntityInfo ?? new LegalEntityInfo());
        // console.log("UserInfo.parseUserInfo()... active legal entity OK");
        newUserInfo.activeUserLegalEntityInfo = UserLegalEntityInfo.parseUserLegalEntityInfo(stringifiedUserInfo.activeUserLegalEntityInfo ?? new UserLegalEntityInfo());
        return newUserInfo;
    }
/*
     public static statusById(id: number): EnumUserStatus {            
        switch (id) {
            case 1: return EnumUserStatus.approval;
            case 2: return EnumUserStatus.active;
            case 3: return EnumUserStatus.refused;
            case 4: return EnumUserStatus.inactive;
            case 5: return EnumUserStatus.suspended;
            case 6: return EnumUserStatus.banned;
            case 7: return EnumUserStatus.erased;
            default: return EnumUserStatus.unknown;
        }
    }

    public static statusIdByEnum(status: EnumUserStatus): number {
        switch(status) {
            case EnumUserStatus.approval: return 1;
            case EnumUserStatus.active: return 2;
            case EnumUserStatus.refused: return 3;
            case EnumUserStatus.inactive: return 4;
            case EnumUserStatus.suspended: return 5;
            case EnumUserStatus.banned: return 6;
            case EnumUserStatus.erased: return 7;
            default: return -1;
        }
    }
    */
}
